import { Button, DropdownMenu } from '@cloudflare/kumo';
import { ReactNode } from 'react';
import { ICONS } from '../ui/icons';

export interface RowAction {
  label: string;
  onClick: () => void;
  /** Ação destrutiva: vai para o fim, depois de um separador, em vermelho (como "Leave Project" no Atlas) */
  destructive?: boolean;
  disabled?: boolean;
  description?: ReactNode;
}

/**
 * Coluna "Ações" no padrão do MongoDB Atlas: botão "…" com menu escuro e,
 * ao lado, a lixeira (quando há exclusão direta).
 *
 * O `Menu` do LeafyGreen virou `ButtonDropdown` do Cloudscape: os itens são
 * um array (`items`) e o clique chega em `onItemClick` com o `id` do item.
 * O `MenuSeparator` não existe no Cloudscape — a separação é mantida pelo
 * agrupamento visual (o `renderItem` desenha a linha divisória antes do
 * primeiro item destrutivo) e pela ordem dos itens.
 */
export function RowActions({ label, actions, onDelete, deleteDisabledReason }: {
  label: string;
  actions: RowAction[];
  onDelete?: () => void;
  deleteDisabledReason?: string | null;
}) {
  const normal = actions.filter((a) => !a.destructive);
  const danger = actions.filter((a) => a.destructive);

  // O `id` do item carrega a ação: o `onItemClick` do Cloudscape devolve o id.
  return (
    <div className="atlas-row-actions">
      {actions.length > 0 && (
        <DropdownMenu>
          <DropdownMenu.Trigger
            render={<Button variant="ghost" shape="square" icon={ICONS.Ellipsis} aria-label={`Mais ações: ${label}`} className="atlas-action-btn" />}
          />
          <DropdownMenu.Content>
            {normal.map((a, i) => (
              <DropdownMenu.Item key={`n${i}`} disabled={a.disabled} onClick={() => a.onClick()}>
                {a.label}
              </DropdownMenu.Item>
            ))}
            {danger.map((a, i) => (
              <DropdownMenu.Item key={`d${i}`} variant="danger" icon={ICONS.Trash} disabled={a.disabled} onClick={() => a.onClick()}>
                {a.label}
              </DropdownMenu.Item>
            ))}
          </DropdownMenu.Content>
        </DropdownMenu>
      )}
      {onDelete && (
        <Button variant="ghost" shape="square" icon={ICONS.Trash} aria-label={`Excluir ${label}`} disabled={!!deleteDisabledReason} onClick={onDelete} className="atlas-action-btn" title={deleteDisabledReason || 'Excluir'} />
      )}
    </div>
  );
}
